import React, { useState } from 'react';
import { Paper, TextField, Button, Typography, Alert } from '@mui/material';
import Grid from '@mui/material/Grid';
import { useNavigate } from 'react-router-dom';
import './login.css'; 

const Login = () => {
    const [phone, setPhone] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError('');

        try {
            const response = await fetch(`${process.env.REACT_APP_API_URL}/admin/login`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({ phone, password }),
            });

            const data = await response.json();

            if (data.success) {
                sessionStorage.setItem('accessToken', JSON.stringify(data.accessToken));
                sessionStorage.setItem('refreshToken', JSON.stringify(data.refreshToken));
                sessionStorage.setItem('user', JSON.stringify(data.user));
                navigate('/admin/dashboard');
            } else {
                setError('Login failed');
            }
        } catch (error) {
            setError('An error occurred. Please try again later.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <Grid
            container
            className="login-container"
        >
            <Grid item xs={10} sm={6} md={4}>
                <Paper elevation={3} className="login-paper">
                    <Typography variant="h5" component="h1" gutterBottom>
                        Login
                    </Typography>
                    <form onSubmit={handleSubmit}>
                        {error && (
                            <Alert severity="error" className="login-error">
                                {error}
                            </Alert>
                        )}
                        <TextField
                            label="Phone"
                            type="text"
                            fullWidth
                            margin="normal"
                            required
                            placeholder="Enter your phone number"
                            value={phone}
                            onChange={(e) => setPhone(e.target.value)}
                        />
                        <TextField
                            label="Password"
                            type="password"
                            fullWidth
                            margin="normal"
                            required
                            placeholder="Enter your password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="primary"
                            fullWidth
                            className="login-button"
                            disabled={loading}
                        >
                            {loading ? 'Logging in...' : 'Login'}
                        </Button>
                    </form>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default Login;